import React from 'react';
import SEO from '../components/SEO';
import { BoltIcon, ServerIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';

export default function Enterprise() {
    return (
        <div className="min-h-screen bg-gray-50 dark:bg-dark-900 pt-20 pb-12">
            <SEO
                title="Enterprise REST API Integration"
                description="Programmatic access to our detection intelligence. Ready for SIEM (Splunk/Sentinel) and automated Webhooks (Phase 3)."
            />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                    <h1 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-5xl md:text-6xl">
                        <span className="block text-mint-600">Enterprise</span>
                        <span className="block">REST API Integration</span>
                    </h1>
                    <p className="mt-3 max-w-md mx-auto text-base text-gray-500 dark:text-gray-400 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
                        Programmatic access to our detection intelligence. Ready for SIEM (Splunk/Sentinel) and automated Webhooks.
                    </p>
                </div>

                <div className="mt-16 bg-white dark:bg-dark-800 rounded-2xl shadow-xl overflow-hidden">
                    <div className="p-8 sm:p-12">
                        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-8">Integration Features</h2>

                        <div className="grid gap-8 md:grid-cols-3">
                            <div className="flex flex-col items-center text-center p-6 bg-gray-50 dark:bg-dark-700 rounded-xl">
                                <div className="flex items-center justify-center h-12 w-12 rounded-md bg-mint-500 text-white mb-4">
                                    <ServerIcon className="h-6 w-6" aria-hidden="true" />
                                </div>
                                <h3 className="text-lg font-medium text-gray-900 dark:text-white">API Access</h3>
                                <p className="mt-2 text-base text-gray-500 dark:text-gray-400">
                                    Full REST API access to trigger scans and retrieve results programmatically.
                                </p>
                            </div>

                            <div className="flex flex-col items-center text-center p-6 bg-gray-50 dark:bg-dark-700 rounded-xl">
                                <div className="flex items-center justify-center h-12 w-12 rounded-md bg-mint-500 text-white mb-4">
                                    <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" />
                                </div>
                                <h3 className="text-lg font-medium text-gray-900 dark:text-white">SIEM Ready</h3>
                                <p className="mt-2 text-base text-gray-500 dark:text-gray-400">
                                    Native format support for Splunk, Azure Sentinel, and generic JSON/CSV exports.
                                </p>
                            </div>

                            <div className="flex flex-col items-center text-center p-6 bg-gray-50 dark:bg-dark-700 rounded-xl">
                                <div className="flex items-center justify-center h-12 w-12 rounded-md bg-mint-500 text-white mb-4">
                                    <BoltIcon className="h-6 w-6" aria-hidden="true" />
                                </div>
                                <h3 className="text-lg font-medium text-gray-900 dark:text-white">Webhooks (Phase 3)</h3>
                                <p className="mt-2 text-base text-gray-500 dark:text-gray-400">
                                    Real-time alerts delivered to your endpoints via secure webhooks.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
